var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VBtn',{staticClass:"wp-base-button",class:{
    'wp-base-button__filled': _vm.outlined === false,
    'wp-base-button__border': _vm.outlined,
  },attrs:{"elevation":"0","outlined":_vm.outlined,"disabled":_vm.disabled,"text":_vm.text,"fab":_vm.fab},on:{"click":_vm.onButtonClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }